<template>
  <Dashboard />
</template>

<script>
import Dashboard from '@/components/ui/dashboard/Dashboard.vue'

export default {
  components: {
    Dashboard
  }
}
</script>
